import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountPaymentCallbackPage} from 'pages/accounts/credits/payment/CreditAccountPaymentCallbackPage';

export const Route = createFileRoute(
  '/_protected/credit-account-payment/callback',
)({
  component: CreditAccountPaymentCallbackPage,
  validateSearch: (search) => {
    return {
      status: search.status as string | undefined,
    };
  },
});
